module.exports = __webpack_public_path__ + "static/img/coupon_bg_zh_invalid.a240386e.png";